import { memo, useEffect, useState } from "react"
import styled from "styled-components"
import UserBeforeEdit from "./EditUser/UserBeforeEdit"
import UserEdit from "./EditUser/UserEdit"
import { AppState, useAppSelector } from "reducers/store"

const ContainerNameEdit = styled.div`
  display: flex;
  gap: 16px;
  align-items: flex-end;
`

const ContainerEdit = styled.div`
  display: grid;
  gap: 10px;
  align-items: flex-start;
`

const UserNameEdit = () => {
  const { name } = useAppSelector((x: AppState) => x.user.userPersonalInfo.data)

  const [isEditing, setEditing] = useState(false)
  const [editedValue, setEditedValue] = useState<{ name: null | string }>({
    name: null
  })

  useEffect(() => {
    if (name && editedValue.name === null) {
      setEditedValue({
        name: name
      })
    }
  }, [name, editedValue])

  return (
    <ContainerNameEdit>
      <ContainerEdit>
        {isEditing && (
          <UserEdit
            setEditing={setEditing}
            editedValue={{ name: editedValue.name || "" }}
            setEditedValue={setEditedValue}
          />
        )}
        {!isEditing && <UserBeforeEdit setEditing={setEditing} editedValue={{ name: editedValue.name || "" }} />}
      </ContainerEdit>
    </ContainerNameEdit>
  )
}

export default memo(UserNameEdit)
